import React, { useEffect, useState } from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
  maincontainer: {
    padding: '45px 0',
    '@media (max-width: 1200px)': {
      boxSizing: 'border-box',
      padding: '45px 0',
    },
    '@media (max-width: 700px)': {
      boxSizing: 'border-box',
    },
  },
  container: {
    padding: '50px 10px',
    overflow: 'hidden',
    '@media (max-width: 700px)': {
      padding: '30px 10px',
    },
    '& > div': {
      margin: '0 auto',
      width: '100%',
      maxWidth: '1220px',
      '@media (max-width: 1220px)': {
        width: 'auto',
        boxSizing: 'border-box',
        marginLeft: 15,
        marginRight: 15,
      },
    },
    '& + &': {
      marginTop: '40px',
    },
    '& *': {
      boxSizing: 'border-box',
    },
  },
  wrapper: {
    minHeight: '400px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '@media (max-width: 700px)': {
      alignItems: 'end',
    },
  },
  shadowbg: {
    backgroundImage: 'linear-gradient(90deg, rgba(0,0,0,0.6) 30%, transparent 80%)',
    backgroundRepeat: 'no-repeat',
    '@media (max-width: 700px)': {
      backgroundImage: 'linear-gradient(360deg, rgba(0,0,0,0.6) 30%, transparent 50%)',
      backgroundRepeat: 'no-repeat',
    },
  },
  contenti: {
    padding: '17px 0',
  },
  image: {
    '& img': {
      maxWidth: '100%',
      height: 'auto',
      borderRadius: '20px',
      verticalAlign: 'bottom',
    },
  },
  title: {
    fontFamily: 'TTRounds',
    textAlign: 'left',
    padding: '0',
    fontSize: '49px',
    fontWeight: 700,
    color: '#fff',
    lineHeight: '1.2',
    maxWidth: '800px',
    '@media (max-width: 700px)': {
      fontSize: '22px',
      lineHeight: '1.4',
    },
    '& a': {
      color: 'inherit',
      textDecoration: 'none',
    },
  },
}))

const FadeContainer = props => {
  const { img, imgMobile, title, noPaddingTop, monteratt } = props

  const [isMobile, setIsMobile] = useState(false)

  const classes = useStyles()

  useEffect(() => {
    if (window.innerWidth < 900) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [])

  return (
    <div className={classes.maincontainer} style={noPaddingTop == '1' ? { paddingTop: 0 } : {}}>
      <div
        style={{
          backgroundImage: `url('${isMobile ? imgMobile : img}')`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
        }}
      >
        <div className={classes.shadowbg}>
          <div className={classes.container}>
            <div className={classes.wrapper}>
              <div
                className={classes.title}
                style={monteratt == '1' ? { fontFamily: 'Montserrat' } : {}}
                dangerouslySetInnerHTML={{ __html: title }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FadeContainer
